export default __webpack_public_path__ + "static/media/individualFemale.7d69be15.svg";